export const LabelBatchStatusStep = {
  Validating: {
    identifier: 'validating',
    ordinal: 0,
  },
  ErrorOrWarning: {
    identifier: 'error-or-warning',
    ordinal: 1,
  },
  CostReview: {
    identifier: 'cost-review',
    ordinal: 2,
  },
  Processing: {
    identifier: 'processing',
    ordinal: 3,
  },
  Loading: {
    identifier: 'loading',
    ordinal: 4,
  },
  SubscriptionLimitError: {
    identifier: 'subscription-error',
    ordinal: 5,
  },
  NoOrdersIncluded: {
    identifier: 'no-orders-included',
    ordinal: 6,
  },
};
